export default __webpack_public_path__ + "static/media/03.67998e53.png";